import {Injectable} from '@angular/core';
import {NavFactory} from './nav.factory';
import {NavItemCodes} from '../../enums/nav-item-codes.enum';
import {PermissionArea} from '../../enums/permission-area.enum';
import {IconCode} from '../../enums/icon-code.enum';

@Injectable()
export class NavPartnerFactory extends NavFactory {
    protected static items = [
        {
            code: NavItemCodes.PARTNER_ACTIVATE,
            icon: IconCode.PARTNER_ACTIVATE,
            label: 'PARTNER.ACTIVATE',
            description: 'PARTNER.ACTIVATE',
        },
        {
            code: NavItemCodes.PARTNER_ADD,
            icon: IconCode.PARTNER_ADD,
            label: 'PARTNER.ADD',
            description: 'PARTNER.ADD',
            path: ['/admin/partners/add'],
            permissionArea: PermissionArea.PARTNER_MANAGEMENT
        },
        {
            code: NavItemCodes.PARTNER_EDIT,
            icon: IconCode.PARTNER_EDIT,
            label: 'PARTNER.EDIT',
            description: 'PARTNER.EDIT',
            path: ({partnerId}) => ['/admin/partner', partnerId, 'edit'],
            permissionArea: PermissionArea.PARTNER_MANAGEMENT
        },
        {
            code: NavItemCodes.PARTNER_DEACTIVATE,
            icon: IconCode.PARTNER_DEACTIVATE,
            label: 'PARTNER.DEACTIVATE',
            description: 'PARTNER.DEACTIVATE',
        },
        {
            code: NavItemCodes.PARTNER_DEACTIVATE_SALES,
            icon: IconCode.PARTNER_DEACTIVATE_SALES,
            label: 'PARTNER.DEACTIVATE_SALES',
            description: 'PARTNER.DEACTIVATE_SALES',
        },
        {
            code: NavItemCodes.PARTNER_MANAGEMENT,
            icon: IconCode.PARTNER_MANAGEMENT,
            label: 'NAV.PARTNER.LABEL',
            description: 'NAV.PARTNER.DESC',
            path: '/admin/partners',
            permissionArea: PermissionArea.PARTNER_MANAGEMENT
        },
    ];
}
